module.exports = "https://static.zego.com/_next/static/images/BrokerMicromobility-526ec930465effb08d331a2b2958af32.svg";